// extracted by mini-css-extract-plugin
export default {"content":"styles_content__rVZ0N","metric":"styles_metric__9lzlB"};